import React from 'react';
import {
  FeatureGatesInitialization,
  FeatureGatesInitializationProps,
} from '@atlassian/feature-gates-react';
import { ClientOptions, FeatureGateEnvironment } from '@atlaskit/feature-gate-js-client';
import { currentEnv, isIsolatedCloud } from '../utilities/env';
import { getStatsigApiKey, statsigTargetApp } from './common';

export type FeatureGatesInitProps = Pick<
  FeatureGatesInitializationProps,
  'identifiers' | 'initializingComponent'
> & {
  onReady: (err?: Error | undefined) => void;
};

const getLocalMode = () => currentEnv === 'local';

const getEnv = (): FeatureGateEnvironment => {
  switch (currentEnv) {
    case 'dev':
    case 'local':
      return FeatureGateEnvironment.Development;
    case 'stg':
    case 'stg-fedm':
    case 'stg-ic':
      return FeatureGateEnvironment.Staging;
    case 'prod':
    case 'prod-fedm':
    case 'prod-ic':
    default:
      return FeatureGateEnvironment.Production;
  }
};

// In IC env, disable the SDK's event-logging path because the url is
// currently hardcoded which fails out https://atlassian.slack.com/archives/C04PR2YE4UC/p1779754680379689
const disabledLoggingForIsolatedCloud: Partial<ClientOptions> = isIsolatedCloud()
  ? { disableAllLogging: true }
  : {};

const options: ClientOptions = {
  targetApp: statsigTargetApp,
  environment: getEnv(),
  apiKey: getStatsigApiKey(),
  localMode: getLocalMode(),
  ...disabledLoggingForIsolatedCloud,
};

export const FeatureGatesInit = ({ identifiers, onReady }: FeatureGatesInitProps) => {
  return (
    <FeatureGatesInitialization
      enabled
      identifiers={identifiers}
      options={options}
      onReady={onReady}
    />
  );
};
